import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";

const CHARGE_HEADER_CONSTANT = ChargeConstant.ChargeHeader;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];

export const INITIAL_CHARGE_HEADER_COL_DEF: any[] = [
    {
        headerName: CHARGE_HEADER_CONSTANT.VESSEL_CODE,
        field: 'vesselCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        width: 150,
    },
    {
        headerName: CHARGE_HEADER_CONSTANT.VOYAGE_CODE,
        field: 'voyageCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        width: 150,
    },
    {
        headerName: CHARGE_HEADER_CONSTANT.CONSORTIUM_CODE,
        field: 'consortiumCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        width: 150,
    },
    {
        headerName: CHARGE_HEADER_CONSTANT.ETD,
        field: 'etd',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        width: 150,
        dataType: "dateTime",
    },
    {
        headerName: CHARGE_HEADER_CONSTANT.VESSEL_NAME,
        field: 'vesselName',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        width: 150,
    },
    {
        headerName: CHARGE_HEADER_CONSTANT.OPS_DATE,
        field: 'opsDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        sortable: true,
        dataType: "date"
    },
].map((col, index) => {
    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], {});
});

export const transferShipboundedRowData = (data: any[]) => {
    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], {});
}